import React from "react";
import { Wrapper } from "./LeadListCardEntity.styled";
import { Button, Row, Col } from "components/common";
import { useHistory } from "react-router";
import { getUserPermissions } from "utils/text";

import createdAt from "../../../../assets/images/created.png";
import address from "../../../../assets/images/address.png";
import appointment from "../../../../assets/images/appointment.png";
import name from "../../../../assets/images/name.png";
import Status from "../../../../assets/images/status.png";
import useredit from "../../../../assets/images/user-edit.png";
import moment from "moment";

const LeadListCardEntity = ({ data, status, users }) => {
    const history = useHistory();
    let statusValue = status?.filter((el) => el.id == data?.status);
    let dateCreated = data?.dateCreated;
    let dateAppointment = data?.appointmentTime;

    return (
        <Wrapper>
            <div className="bg-black border-radius-10 flex" style={{ padding: "10px" }}>
                <h5 className="white">
                    {data?.firstName} {data?.lastName}
                </h5>
                {getUserPermissions("edit-lead-action") && (
                    <img
                        src={useredit}
                        alt="edit"
                        className="cursor"
                        onClick={() => {
                            history.push(`lead/${data?._id}`);
                        }}
                    />
                )}
            </div>
            <br />
            <div>
                <div className="flex">
                    <h5>
                        <img src={Status} alt="status" />
                        &nbsp; {statusValue?.[0]?.name || "New"}
                    </h5>

                    <h5>
                        <img src={name} alt="name" />
                        &nbsp; {data?.setter?.username ? data?.setter?.username : users?.find((e) => e.id === data?.setter)?.name}
                    </h5>
                    
                </div>
                <div className="flex mt-10">
                    <h5>
                        <img src={appointment} alt="appointment" />
                        &nbsp; {dateAppointment ? moment(dateAppointment).format("YYYY-MM-DD") : ""}
                    </h5>

                    <h5>
                        <img src={createdAt} alt="created" />
                        &nbsp; {dateCreated ? moment(dateCreated)?.format("YYYY-MM-DD") : ""}
                    </h5>
                </div>
                {(data?.address || data?.city || data?.state) && (
                    <div className="flex mt-15">
                        <h5>
                            <img src={address} alt="address" />
                            &nbsp; {data.street} , {data.city} , {data.state}
                        </h5>
                    </div>
                )}
            </div>
        </Wrapper>
    );
};

export default LeadListCardEntity;
